import { render } from "./chatRightList.vue?vue&type=template&id=44ea9445&scoped=true"
import script from "./chatRightList.vue?vue&type=script&lang=js"
export * from "./chatRightList.vue?vue&type=script&lang=js"

import "./chatRightList.vue?vue&type=style&index=0&id=44ea9445&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/aikangmall-im-seller/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ea9445"]])

export default __exports__